<div
  class="table-row"
  [ngClass]="'table-row--' + state"
  [style.grid-template-columns]="gridSize"
  [style.width]="active ? tableContentClientWidthPx + 'px' : 'unset'"
  prlwSyncScroll
  [scrollSyncIsActive]="active"
  [syncScrollRefresh$]="scrollRefresh$"
  (click)="toggleActive.emit()"
  prlwResponsive
>
  <prlw-table-column-content
    *ngFor="let column of columns"
    [columnId]="column.id"
    [instrument]="instrument"
    [valueChanges]="valueChanges"
    [isHovered]="hovered"
    [isActive]="active"
    [class.on-top]="isOnTop(column.id)"
    prlwResponsive
  ></prlw-table-column-content>
</div>
<prlw-instrument-remove-button
  *ngIf="active"
  class="basis-remove-button"
  (click)="removeBasis.emit()"
></prlw-instrument-remove-button>
<div *ngIf="active">
  <div class="grey-line"></div>
  <div class="instrument-info">
    <prlw-basis-details-ui
      [instrument]="instrument"
      [unpinned]="unpinned"
    ></prlw-basis-details-ui>
  </div>
</div>
